import { Injectable } from '@angular/core';
import { LoadingProvider } from './loading';
import { AlertProvider } from './alert';
import { DataProvider } from './data';
import { UserProvider } from './user';

// import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/take';

@Injectable()
export class FirebaseProvider {
  // Firebase Provider
  // This is the provider class for most of the Firebase updates in the app.

  constructor(public loadingProvider: LoadingProvider, public alertProvider: AlertProvider, public dataProvider: DataProvider, public userProvider: UserProvider) {
    console.log("Initializing Firebase Provider");
  }

  // Send friend request to userId.
  sendFriendRequest(userId) {

  }

  // Cancel friend request sent to userId.
  cancelFriendRequest(userId) {

  }

  // Delete friend request.
  deleteFriendRequest(userId) {

  }

  // Accept friend request.
  acceptFriendRequest(userId) {

  }

  tryEnablePush() {

  }
}



// WEBPACK FOOTER //
// ./src/providers/firebase.ts